var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 41,
    viewBox: "0 0 54 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector 3",
    d: "M0 39.7417L7.74489 0H34.9797L32.0009 15.4882H38.9798C37.0703 23.027 34.0647 25.5126 21.4474 23.4025L24.6815 7.659H15.7451L11.2344 31.1466C36.2472 32.574 43.18 30.6734 45.3629 23.4025H53.4483C50.129 39.7417 38.0159 42.0988 0 39.7417Z",
    fill: "#F8B232"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.2a737e62e4f2765df61436a911972b12.svg";
export { ForwardRef as ReactComponent };